import { I18_EN } from './i18-en';
import { I18_ES } from './i18-es';

export const I18 = {
  EN: I18_EN,
  ES: I18_ES,
};
